// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../images/banner.jpg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../images/bayi.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.cdnfonts.com/css/sf-pro-display);"]);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `html > * {
  font-family: "SF Pro Display", sans-serif;
}

.header,
.footer {
  padding: 20px 0;
  text-align: center;
}

.footer {
  overflow-x: auto;
}

.footer::-webkit-scrollbar {
  height: 6px;
}

.table-standart td.text-justify svg {
  margin-right: 8px;
}

.footer::-webkit-scrollbar-thumb {
  background-color: grey;
  border-radius: 10px;
}

.footer::-webkit-scrollbar-track {
  background-color: black;
}

body {
  /* background-color: #000000; */
}

.custom-bg {
  padding: 10px;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-size: 100%;
}

.custom-alert {
  border: 0 !important;
  color: #fff;
  background: transparent !important;
}

.custom-bg {
  border: 5px solid transparent;
  border-image: linear-gradient(
      45deg,
      #6e0000,
      #007da0,
      #00a000,
      #a0007d,
      #6e0000
    )
    30 stretch;
  margin-bottom: 40px;
  animation: borderMove 10s infinite;
}

@keyframes borderMove {
  0% {
    border-image: linear-gradient(
        45deg,
        #6e0000,
        #007da0,
        #00a000,
        #a0007d,
        #6e0000
      )
      30 stretch;
  }
  20% {
    border-image: linear-gradient(
        45deg,
        #007da0,
        #00a000,
        #a0007d,
        #6e0000,
        #6e0000
      )
      30 stretch;
  }
  40% {
    border-image: linear-gradient(
        45deg,
        #00a000,
        #a0007d,
        #6e0000,
        #007da0,
        #6e0000
      )
      30 stretch;
  }
  60% {
    border-image: linear-gradient(
        45deg,
        #a0007d,
        #6e0000,
        #007da0,
        #00a000,
        #6e0000
      )
      30 stretch;
  }
  80% {
    border-image: linear-gradient(
        45deg,
        #6e0000,
        #007da0,
        #00a000,
        #a0007d,
        #6e0000
      )
      30 stretch;
  }
  100% {
    border-image: linear-gradient(
        45deg,
        #6e0000,
        #007da0,
        #00a000,
        #a0007d,
        #6e0000
      )
      30 stretch;
  }
}

.product-list {
  background: #000000ad;
  padding: 0 22px;
}

.drop-item {
  cursor: pointer;
}

.product-list ul {
  list-style-type: none;
  padding: 0;
}
.product-list li {
  width: 100%;
  padding: 0 5px;
  transition: 0.3s;
  overflow: hidden;
}

.whatsapp {
  position: fixed;
  bottom: 20px;
  right: 20px;
  background: #25d366;
  border-radius: 50px;
  padding: 8px 10px 10px 10px;
}
.ping {
  background: #25d366;
  border-radius: 50%;
  border: 50px solid #222;
  width: 65px;
  border: 10px solid #ffffff00;
  height: 65px;
  animation: load 2.5s ease-out infinite;
}

.excel-wrapper {
  cursor: pointer;
  position: fixed;
  bottom: 95px;
  right: 30px;
  width: 50px;
  height: 50px;
  border-radius: 50%;
  background: #d38d25;
  padding: 10px;
  display: flex;
  justify-content: center;
  align-items: center;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.2);
  transition: transform 0.2s ease, background 0.2s ease;
}

.excel-wrapper:hover {
  transform: scale(1.1); /* Hover efekti için büyütme */
  background: #b3751e;
}

.svg-excel {
  fill: #fff;
  height: 25px;
  width: 25px;
}

.contact-sub-wrapper {
  padding-top: 10px;
  padding-left: 25px;
  text-align: left;
}

.apply-wrapper {
  cursor: pointer;
  position: fixed;
  bottom: 160px; /* Excel butonundan yukarı */
  right: 30px;
  width: 50px;
  height: 50px;
  border-radius: 50%;
  background: #e63946;
  padding: 10px;
  display: flex;
  justify-content: center;
  align-items: center;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.2);
  transition: transform 0.2s ease, background 0.2s ease;
}

.apply-wrapper:hover {
  transform: scale(1.1); /* Hover efekti için büyütme */
  background: #d62839;
}

.svg-apply {
  fill: #fff;
  height: 35px;
  width: 35px;
}

@keyframes load {
  0% {
    background: #25d366;
    border: 10px solid #25d3657a;
  }
  50% {
    background: #25d366;
    border: 10px solid #222;
  }
  100% {
    background: #25d366;
    border: 10px solid #000;
  }
}

.item-name {
  color: #fff;
  font-size: 15px;
  font-weight: bold;
  transition: 0.3s;
}

.logo-footer {
  max-width: 200px;
}

.item-wrapper:hover .custom-alert,
.item-wrapper:hover .item-name,
.item-wrapper:hover .price {
  color: #e80047;
}
.item-wrapper:hover {
  background-color: #000;
}
.accordion-header .item-wrapper:hover {
  background-color: #000;
}

.color-circle {
  width: 20px;
  height: 20px;
  border-radius: 50%;
  display: inline-block;
  margin-right: 5px;
  border: solid 1px #d6d8db;
}
.info-box {
  padding: 20px;
  margin-bottom: 20px;
}
.card-custom {
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #f8f9fa;
  margin-bottom: 20px;
  border-radius: 3px;
}
.campaign-img {
  border-radius: 3px;
  max-width: 100%;
  height: auto;
  margin-bottom: 20px;
}

.alert {
  height: 25px;
  width: 90px;
  padding: 5px 0px !important;
  text-align: center;
  font-size: 11px;
  font-weight: bold;
}

.card-header {
  padding: 0.75rem 6px;
}

.card-title {
  display: flex;
  justify-content: space-between;
}

table tr {
  transition: 0.3s;
}

table tr:hover {
  background-color: #0000003a;
}

.banks {
  color: #fff;
  font-weight: bold;
  font-size: 12px;
}

.accordion-header button {
  width: 100%;
  background: #000;
  border: 0;
  padding: 0;
  margin: 0;
  outline: 0;
}

.accordion-header {
  font-size: 30px;
  margin-bottom: 0;
}

.accordion-body {
  margin-bottom: 15px;
}

.accordion-body .item-wrapper {
  margin: 0;
  padding: 0;
}

.accordion-body .item-name {
  padding-left: 20px;
}

.m-1.alert.alert-danger,
.m-1.alert.alert-success {
  padding: 7px 0px;
}

.options {
  background-color: #242424;
  color: #fff;
  font-size: 12px;
}

.item-wrapper {
  border-radius: 0px;
  margin: 0 0 2px 0;
  padding: 5px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  transition: 0.2s;
  background: #212121b8;
  border: solid 1px #363636;
}
.item-wrappers {
  border-radius: 0px;
  margin: 0 0 2px 0;
  padding: 5px;

  justify-content: space-between;
  align-items: center;
  transition: 0.2s;
  background: #212121b8;
  border: solid 1px #363636;
}

.price {
  transition: 0.2s;
  padding: 0 10px;
  font-weight: bold;
  font-size: 14px;
  width: 100px;
  text-align: right;
}

.table-bordered td,
.table-bordered th {
  color: #fff;
}

.card-title {
  height: 60px;
  align-items: center;
}

.dealer-title {
  text-align: center;
  font-size: 80px;
  padding: 0px 100px;
  color: #fff;
}

.card-title img.Huawei,
.card-title img.OnePlus,
.card-title img.Reeder,
.card-title img.Apple {
  height: 60px;
}

.card-title img.Omix {
  height: 50px;
}
.card-title img.Xiaomi,
.card-title img.TCL,
.card-title img.Oppo,
.card-title img.RealMe,
.card-title img.Tecno {
  height: 45px;
}

.card-title img.Poco,
.card-title img.Vivo,
.card-title img.Samsung {
  height: 40px;
}

.custom-container {
  background-color: #000;
}

.table-standart {
  background: linear-gradient(62deg, rgb(42, 63, 181) 0%, rgb(98, 29, 52) 100%);
  color: #fff;
  border-radius: 20px;
}

.table-standart thead th {
  border: 0;
}

.table-standart tr {
  display: flex;
  align-items: center;
}

.table-standart td,
.table-standart th {
  border: 0;
}

.table-standart td strong {
  font-size: 18px;
}

.table-standart ul {
  text-align: left;
}

.table-standart ul li svg {
  margin-right: 8px;
}

table {
  background: linear-gradient(
    62deg,
    rgba(42, 181, 128, 1) 0%,
    rgba(31, 29, 98, 1) 100%
  );
}
.tablecolor {
  background: #212121b8;
}

.card {
  background-color: transparent;
  color: #f8f9fa;
}

.card-body ul li {
  align-items: center;
}

.title-2 {
  text-align: center;
  font-weight: bold;
  display: inline-block;
  color: #fff;
  transition: 0.2s;
  cursor: default;
}

.contact-title {
  font-size: 32px !important;
}

.alert-success {
  color: #fff;
  background-color: #00a473;
  border-color: rgb(73, 219, 107);
}

.alert-danger {
  color: #fff;
  background-color: #a40000;
  border-color: rgb(219, 73, 73);
}

.box1,
.box2,
.box3 {
  transition: 0.3s;
  min-height: 200px;
}

.hr-spec {
  background-image: linear-gradient(
    to right,
    rgba(105, 105, 105, 0.438),
    rgb(255 255 255 / 20%),
    transparent
  );
  margin: 5px;
  border: 0;
  height: 1px;
}

.box3:hover,
.box1 {
  color: #fff;
  background: linear-gradient(to right, #1b2f3b 50%, #000000 100%);
  border: 5px solid transparent;
  border-image: linear-gradient(to right, #6e0000 0%, #007da0 100%) 30 stretch;
}
.box2 {
  color: #fff;
  background: linear-gradient(to right, #332e15 50%, #000000 100%);
  border: 5px solid transparent;
  border-image: linear-gradient(to right, #00ffaa 0%, #2643e5 100%) 30 stretch;
}

.box2:hover,
.box1:hover,
.box3 {
  color: #fff;
  background: linear-gradient(to right, #3f1515 50%, #000000 100%);
  border: 5px solid transparent;
  border-image: linear-gradient(to right, #8e10f0 0%, #e52672 100%) 30 stretch;
}

html {
  overflow-y: auto;
}

.header-heart {
  animation: glowHeader 2s ease-in-out infinite alternate;
}

@keyframes glowHeader {
  0% {
    opacity: 0.9;
  }
  100% {
    opacity: 1;
  }
}

hr {
  border: 1px solid transparent;
  border-image: linear-gradient(to right, #8e10f0 0%, #e52672 100%) 30;
}

.title-wrapper {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 50px;
}

.border-x-side {
  border-radius: 0 !important;
  border-left: 1px solid #7f7f7f !important;
  border-right: 1px solid #7f7f7f !important;
}

h1 {
  cursor: default;
  /* max-width: 75%; */
  font-size: 75px;
  text-align: center;
  font-family: "Montserrat", sans-serif;
  color: #540032;
}

h2 {
  cursor: default;
  font-size: 45px;
}

.contact-wrapper {
  display: flex;
  justify-content: end;
}

#urunler {
  overflow: hidden;
}

.fz-17 {
  text-align: left;
  font-size: 17px !important;
}
.contact {
  text-decoration: none;
  color: #fff;
  font-size: 20px;
  text-align: right;
  display: inline-block;
  margin: 0;
  cursor: pointer;
  border-top: 0 !important;
  border-bottom: 1px solid transparent;
  border-image: linear-gradient(to right, #00ffaa 0%, #2643e5 100%) 30 stretch;

  padding: 10px;
  transition: 0.2s;
}

.contact-spec {
  background-color: #e50046 !important;
  color: #fff;
  background: #000;
  border-image: none !important;
}

.contact:hover {
  border-image: linear-gradient(to right, #8e10f0 0%, #e52672 100%) 30 stretch;
}

a:hover {
  text-decoration: none;
}

@media (max-width: 1200px) {
  h1 {
    font-size: 70px;
    max-width: 100%;
    width: 100%;
  }
  h2 {
    font-size: 30px;
  }

  .title {
    max-width: 100%;
  }
}

@media (max-width: 992px) {
  .contact-sub-wrapper .contact-sub-title {
    text-align: center;
    display: block;
    padding-bottom: 10px;
  }

  h1 {
    font-size: 60px;
  }
  h2 {
    font-size: 25px;
  }
  .contact {
    font-size: 14px;
  }
  a.dealder-area {
    display: flex;
    align-items: center;
  }
  .register-form-link {
    font-size: 16px;
  }
  .dealer-title {
    font-size: 50px;
  }
}

@media (max-width: 768px) {
  h1 {
    font-size: 38px;
  }
  .header-heart h2 {
    display: none !important;
  }
}

@media (max-width: 576px) {
  h1 {
    font-size: 38px;
  }
}

#iletisim ul {
  padding: 5px;
}

#iletisim ul li {
  cursor: pointer;
  transition: 0.2s;
}

.contact-sub-wrapper a {
  transition: 0.2s;
  padding-left: 10px;
}

.contact-sub-wrapper a:hover,
#iletisim ul li:hover {
  color: #e50046 !important;
}

.contact-sub-wrapper svg,
#iletisim li svg {
  padding-right: 5px;
}

.registerBanner {
  filter: brightness(0.7);
}

.box-info-label-area {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  width: 100%;
}

.box-info-label li {
  margin-top: 10px;
  transition: 0.3s;
  padding: 0px 0px 0px 10px;
  cursor: default;
}

.box-info-label .li-1 {
  width: 270px;
  background: linear-gradient(45deg, #000000 0%, #e50046 100%) !important;
  clip-path: polygon(90% 0%, 100% 100%, 100% 100%, 0% 100%, 0 0%, 0% 0%);
}

.box-info-label .li-2 {
  width: 300px;
  background: linear-gradient(45deg, #000000 0%, #860028 100%) !important;
  clip-path: polygon(91% 0%, 100% 100%, 100% 100%, 0% 100%, 0 0%, 0% 0%);
}

.box-info-label .li-3 {
  width: 330px;
  background: linear-gradient(45deg, #000000 0%, #58001b 100%) !important;
  clip-path: polygon(92% 0%, 100% 100%, 100% 100%, 0% 100%, 0 0%, 0% 0%);
}

.box-info-label .li-4 {
  width: 360px;
  background: linear-gradient(45deg, #000000 0%, #360010 100%) !important;
  clip-path: polygon(92% -0%, 100% 100%, 100% 100%, 0% 100%, 0 0%, 0% 0%);
}

.box-info-label li:hover {
  filter: grayscale(1);
}

.center-object {
  align-items: center;
  display: flex;
  justify-content: center;
}

.box-info-label svg {
  font-size: 35px;
  color: #fff;
  width: 40px;
  padding-bottom: 5px;
}

.box-info-label span {
  padding-left: 10px;
  font-size: 52px;
  color: #fff;
}

.dealer-button {
  color: #fff;
  transition: 0.2s;
  padding: 15px;
  border-radius: 5px;
  display: inline-block;
  border: solid 3px #fff;
  cursor: pointer;
}

.dealer-text {
  text-align: center;
  padding: 20px 15% !important;
}

.dealer-button:hover {
  text-shadow: 1px 1px 10px #e50046, 1px 1px 10px #e50046;
  border: solid 3px #e50046;
  color: #e50046;
}

.stat {
  border-radius: 40px;
}

.parallax {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
  min-height: 400px;
  padding-top: 20px;
  background-attachment: fixed;
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
}

.title {
  background-image: url(https://cdn.pixabay.com/photo/2017/07/03/20/17/abstract-2468874_960_720.jpg);
  background-attachment: fixed;
  -webkit-text-fill-color: #ffffff9d;
  -webkit-background-clip: text;
  display: flex;
  justify-content: center;
  transition: 0.3s;
}

.register-form-title,
.contact.mx-2:hover,
.title:hover {
  text-shadow: rgba(255, 255, 255, 0.6) 0px 0px 39px;
}

.register-container {
  background-color: #000;
  color: #fff;
  padding: 20px;
}

.register-container .form-control {
  background-color: #333;
  color: #fff;
  border: 1px solid #555;
}

.register-container .form-control:focus {
  background-color: #444;
  color: #fff;
  border: 1px solid #777;
}

.register-container .btn-primary {
  background-color: #007bff;
  border: none;
}

.register-container .btn-primary:hover {
  background-color: #0056b3;
}

.register-container .required {
  color: red;
}

#formArea {
  opacity: 1;
  transition: 0.3s;
  border: 1px solid transparent;
  border-image: linear-gradient(to right, #ff0000 0%, #9700e5 100%) 30 stretch;
  box-shadow: 1px 1px 10px #ff0000, 1px 1px 10px #6f00ff;
}

.h-0 {
  height: 0;
  opacity: 0 !important;
}

.registerForm .form-group {
  margin-bottom: 1rem;
  color: #fff;
}

.registerForm label {
  margin-left: 10px;
}

.registerForm .required {
  color: #d80000;
}

.response {
  width: 100%;
  height: 35px;
  font-size: 14px;
}

.register-form-title {
  font-size: 70px;
  margin: auto;
  padding: 40px 0px;
  background-clip: text;
}

.react-tel-input .country-list .country,
.selected-flag,
.registerForm .form-control {
  background-color: #000 !important;
  color: #fff !important;
}

.registerForm button {
  background-color: #ba053c;
  border: #58001b;
}

.registerForm button:active,
.registerForm button:focus,
.registerForm button:hover {
  background-color: #800026 !important;
  border: #58001b !important;
}
`, "",{"version":3,"sources":["webpack://./src/assets/css/App.css"],"names":[],"mappings":"AAEA;EACE,yCAAyC;AAC3C;;AAEA;;EAEE,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,aAAa;EACb,mDAAuC;EACvC,qBAAqB;AACvB;;AAEA;EACE,oBAAoB;EACpB,WAAW;EACX,kCAAkC;AACpC;;AAEA;EACE,6BAA6B;EAC7B;;;;;;;;cAQY;EACZ,mBAAmB;EACnB,kCAAkC;AACpC;;AAEA;EACE;IACE;;;;;;;;gBAQY;EACd;EACA;IACE;;;;;;;;gBAQY;EACd;EACA;IACE;;;;;;;;gBAQY;EACd;EACA;IACE;;;;;;;;gBAQY;EACd;EACA;IACE;;;;;;;;gBAQY;EACd;EACA;IACE;;;;;;;;gBAQY;EACd;AACF;;AAEA;EACE,qBAAqB;EACrB,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,qBAAqB;EACrB,UAAU;AACZ;AACA;EACE,WAAW;EACX,cAAc;EACd,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,WAAW;EACX,mBAAmB;EACnB,mBAAmB;EACnB,2BAA2B;AAC7B;AACA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,uBAAuB;EACvB,WAAW;EACX,4BAA4B;EAC5B,YAAY;EACZ,sCAAsC;AACxC;;AAEA;EACE,eAAe;EACf,eAAe;EACf,YAAY;EACZ,WAAW;EACX,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,aAAa;EACb,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,wCAAwC;EACxC,qDAAqD;AACvD;;AAEA;EACE,qBAAqB,EAAE,8BAA8B;EACrD,mBAAmB;AACrB;;AAEA;EACE,UAAU;EACV,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,eAAe;EACf,aAAa,EAAE,4BAA4B;EAC3C,WAAW;EACX,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,aAAa;EACb,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,wCAAwC;EACxC,qDAAqD;AACvD;;AAEA;EACE,qBAAqB,EAAE,8BAA8B;EACrD,mBAAmB;AACrB;;AAEA;EACE,UAAU;EACV,YAAY;EACZ,WAAW;AACb;;AAEA;EACE;IACE,mBAAmB;IACnB,4BAA4B;EAC9B;EACA;IACE,mBAAmB;IACnB,uBAAuB;EACzB;EACA;IACE,mBAAmB;IACnB,uBAAuB;EACzB;AACF;;AAEA;EACE,WAAW;EACX,eAAe;EACf,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;;;EAGE,cAAc;AAChB;AACA;EACE,sBAAsB;AACxB;AACA;EACE,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,qBAAqB;EACrB,iBAAiB;EACjB,yBAAyB;AAC3B;AACA;EACE,aAAa;EACb,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,kBAAkB;AACpB;AACA;EACE,kBAAkB;EAClB,eAAe;EACf,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,2BAA2B;EAC3B,kBAAkB;EAClB,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,8BAA8B;AAChC;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,SAAS;EACT,UAAU;EACV,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,kBAAkB;AACpB;;AAEA;;EAEE,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,YAAY;EACZ,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,gBAAgB;EAChB,qBAAqB;EACrB,yBAAyB;AAC3B;AACA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,YAAY;;EAEZ,8BAA8B;EAC9B,mBAAmB;EACnB,gBAAgB;EAChB,qBAAqB;EACrB,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,eAAe;EACf,YAAY;EACZ,iBAAiB;AACnB;;AAEA;;EAEE,WAAW;AACb;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,WAAW;AACb;;AAEA;;;;EAIE,YAAY;AACd;;AAEA;EACE,YAAY;AACd;AACA;;;;;EAKE,YAAY;AACd;;AAEA;;;EAGE,YAAY;AACd;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,6EAA6E;EAC7E,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,aAAa;EAEb,mBAAmB;AACrB;;AAEA;;EAEE,SAAS;AACX;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE;;;;GAIC;AACH;AACA;EACE,qBAAqB;AACvB;;AAEA;EACE,6BAA6B;EAC7B,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,qBAAqB;EACrB,WAAW;EACX,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,+BAA+B;AACjC;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,8BAA8B;AAChC;;AAEA;;;EAGE,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE;;;;;GAKC;EACD,WAAW;EACX,SAAS;EACT,WAAW;AACb;;AAEA;;EAEE,WAAW;EACX,gEAAgE;EAChE,6BAA6B;EAC7B,4EAA4E;AAC9E;AACA;EACE,WAAW;EACX,gEAAgE;EAChE,6BAA6B;EAC7B,4EAA4E;AAC9E;;AAEA;;;EAGE,WAAW;EACX,gEAAgE;EAChE,6BAA6B;EAC7B,4EAA4E;AAC9E;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,uDAAuD;AACzD;;AAEA;EACE;IACE,YAAY;EACd;EACA;IACE,UAAU;EACZ;AACF;;AAEA;EACE,6BAA6B;EAC7B,oEAAoE;AACtE;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,2BAA2B;EAC3B,yCAAyC;EACzC,0CAA0C;AAC5C;;AAEA;EACE,eAAe;EACf,oBAAoB;EACpB,eAAe;EACf,kBAAkB;EAClB,qCAAqC;EACrC,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,oBAAoB;AACtB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,0BAA0B;AAC5B;AACA;EACE,qBAAqB;EACrB,WAAW;EACX,eAAe;EACf,iBAAiB;EACjB,qBAAqB;EACrB,SAAS;EACT,eAAe;EACf,wBAAwB;EACxB,oCAAoC;EACpC,4EAA4E;;EAE5E,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,oCAAoC;EACpC,WAAW;EACX,gBAAgB;EAChB,6BAA6B;AAC/B;;AAEA;EACE,4EAA4E;AAC9E;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE;IACE,eAAe;IACf,eAAe;IACf,WAAW;EACb;EACA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA;EACE;IACE,kBAAkB;IAClB,cAAc;IACd,oBAAoB;EACtB;;EAEA;IACE,eAAe;EACjB;EACA;IACE,eAAe;EACjB;EAIA;IACE,eAAe;EACjB;EACA;IACE,aAAa;IACb,mBAAmB;EACrB;EACA;IACE,eAAe;EACjB;EACA;IACE,eAAe;EACjB;AAfF;;AAkBA;EACE;IACE,eAAe;EACjB;EACA;IACE,wBAAwB;EAC1B;AACF;;AAEA;EACE;IACE,eAAe;EACjB;AACF;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;;EAEE,yBAAyB;AAC3B;;AAEA;;EAEE,kBAAkB;AACpB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,uEAAuE;EACvE,sEAAsE;AACxE;;AAEA;EACE,YAAY;EACZ,uEAAuE;EACvE,sEAAsE;AACxE;;AAEA;EACE,YAAY;EACZ,uEAAuE;EACvE,sEAAsE;AACxE;;AAEA;EACE,YAAY;EACZ,uEAAuE;EACvE,uEAAuE;AACzE;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,WAAW;AACb;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,aAAa;EACb,kBAAkB;EAClB,qBAAqB;EACrB,sBAAsB;EACtB,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,4BAA4B;AAC9B;;AAEA;EACE,uDAAuD;EACvD,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,yDAA2C;EAC3C,iBAAiB;EACjB,iBAAiB;EACjB,4BAA4B;EAC5B,2BAA2B;EAC3B,4BAA4B;EAC5B,sBAAsB;AACxB;;AAEA;EACE,kGAAkG;EAClG,4BAA4B;EAC5B,kCAAkC;EAClC,6BAA6B;EAC7B,aAAa;EACb,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;;;EAGE,kDAAkD;AACpD;;AAEA;EACE,sBAAsB;EACtB,WAAW;EACX,aAAa;AACf;;AAEA;EACE,sBAAsB;EACtB,WAAW;EACX,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;EACtB,WAAW;EACX,sBAAsB;AACxB;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,UAAU;EACV,gBAAgB;EAChB,6BAA6B;EAC7B,4EAA4E;EAC5E,sDAAsD;AACxD;;AAEA;EACE,SAAS;EACT,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EAInB,WAAW;AAHb;;AAMA;EACE,iBAAiB;AACnB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,iBAAiB;EACjB,qBAAqB;AACvB;;AAEA;;;EAGE,iCAAiC;EACjC,sBAAsB;AACxB;;AAEA;EACE,yBAAyB;EACzB,eAAe;AACjB;;AAEA;;;EAGE,oCAAoC;EACpC,0BAA0B;AAC5B","sourcesContent":["@import url(\"https://fonts.cdnfonts.com/css/sf-pro-display\");\n\nhtml > * {\n  font-family: \"SF Pro Display\", sans-serif;\n}\n\n.header,\n.footer {\n  padding: 20px 0;\n  text-align: center;\n}\n\n.footer {\n  overflow-x: auto;\n}\n\n.footer::-webkit-scrollbar {\n  height: 6px;\n}\n\n.table-standart td.text-justify svg {\n  margin-right: 8px;\n}\n\n.footer::-webkit-scrollbar-thumb {\n  background-color: grey;\n  border-radius: 10px;\n}\n\n.footer::-webkit-scrollbar-track {\n  background-color: black;\n}\n\nbody {\n  /* background-color: #000000; */\n}\n\n.custom-bg {\n  padding: 10px;\n  background: url(\"../images/banner.jpg\");\n  background-size: 100%;\n}\n\n.custom-alert {\n  border: 0 !important;\n  color: #fff;\n  background: transparent !important;\n}\n\n.custom-bg {\n  border: 5px solid transparent;\n  border-image: linear-gradient(\n      45deg,\n      #6e0000,\n      #007da0,\n      #00a000,\n      #a0007d,\n      #6e0000\n    )\n    30 stretch;\n  margin-bottom: 40px;\n  animation: borderMove 10s infinite;\n}\n\n@keyframes borderMove {\n  0% {\n    border-image: linear-gradient(\n        45deg,\n        #6e0000,\n        #007da0,\n        #00a000,\n        #a0007d,\n        #6e0000\n      )\n      30 stretch;\n  }\n  20% {\n    border-image: linear-gradient(\n        45deg,\n        #007da0,\n        #00a000,\n        #a0007d,\n        #6e0000,\n        #6e0000\n      )\n      30 stretch;\n  }\n  40% {\n    border-image: linear-gradient(\n        45deg,\n        #00a000,\n        #a0007d,\n        #6e0000,\n        #007da0,\n        #6e0000\n      )\n      30 stretch;\n  }\n  60% {\n    border-image: linear-gradient(\n        45deg,\n        #a0007d,\n        #6e0000,\n        #007da0,\n        #00a000,\n        #6e0000\n      )\n      30 stretch;\n  }\n  80% {\n    border-image: linear-gradient(\n        45deg,\n        #6e0000,\n        #007da0,\n        #00a000,\n        #a0007d,\n        #6e0000\n      )\n      30 stretch;\n  }\n  100% {\n    border-image: linear-gradient(\n        45deg,\n        #6e0000,\n        #007da0,\n        #00a000,\n        #a0007d,\n        #6e0000\n      )\n      30 stretch;\n  }\n}\n\n.product-list {\n  background: #000000ad;\n  padding: 0 22px;\n}\n\n.drop-item {\n  cursor: pointer;\n}\n\n.product-list ul {\n  list-style-type: none;\n  padding: 0;\n}\n.product-list li {\n  width: 100%;\n  padding: 0 5px;\n  transition: 0.3s;\n  overflow: hidden;\n}\n\n.whatsapp {\n  position: fixed;\n  bottom: 20px;\n  right: 20px;\n  background: #25d366;\n  border-radius: 50px;\n  padding: 8px 10px 10px 10px;\n}\n.ping {\n  background: #25d366;\n  border-radius: 50%;\n  border: 50px solid #222;\n  width: 65px;\n  border: 10px solid #ffffff00;\n  height: 65px;\n  animation: load 2.5s ease-out infinite;\n}\n\n.excel-wrapper {\n  cursor: pointer;\n  position: fixed;\n  bottom: 95px;\n  right: 30px;\n  width: 50px;\n  height: 50px;\n  border-radius: 50%;\n  background: #d38d25;\n  padding: 10px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.2);\n  transition: transform 0.2s ease, background 0.2s ease;\n}\n\n.excel-wrapper:hover {\n  transform: scale(1.1); /* Hover efekti için büyütme */\n  background: #b3751e;\n}\n\n.svg-excel {\n  fill: #fff;\n  height: 25px;\n  width: 25px;\n}\n\n.contact-sub-wrapper {\n  padding-top: 10px;\n  padding-left: 25px;\n  text-align: left;\n}\n\n.apply-wrapper {\n  cursor: pointer;\n  position: fixed;\n  bottom: 160px; /* Excel butonundan yukarı */\n  right: 30px;\n  width: 50px;\n  height: 50px;\n  border-radius: 50%;\n  background: #e63946;\n  padding: 10px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.2);\n  transition: transform 0.2s ease, background 0.2s ease;\n}\n\n.apply-wrapper:hover {\n  transform: scale(1.1); /* Hover efekti için büyütme */\n  background: #d62839;\n}\n\n.svg-apply {\n  fill: #fff;\n  height: 35px;\n  width: 35px;\n}\n\n@keyframes load {\n  0% {\n    background: #25d366;\n    border: 10px solid #25d3657a;\n  }\n  50% {\n    background: #25d366;\n    border: 10px solid #222;\n  }\n  100% {\n    background: #25d366;\n    border: 10px solid #000;\n  }\n}\n\n.item-name {\n  color: #fff;\n  font-size: 15px;\n  font-weight: bold;\n  transition: 0.3s;\n}\n\n.logo-footer {\n  max-width: 200px;\n}\n\n.item-wrapper:hover .custom-alert,\n.item-wrapper:hover .item-name,\n.item-wrapper:hover .price {\n  color: #e80047;\n}\n.item-wrapper:hover {\n  background-color: #000;\n}\n.accordion-header .item-wrapper:hover {\n  background-color: #000;\n}\n\n.color-circle {\n  width: 20px;\n  height: 20px;\n  border-radius: 50%;\n  display: inline-block;\n  margin-right: 5px;\n  border: solid 1px #d6d8db;\n}\n.info-box {\n  padding: 20px;\n  margin-bottom: 20px;\n}\n.card-custom {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  background-color: #f8f9fa;\n  margin-bottom: 20px;\n  border-radius: 3px;\n}\n.campaign-img {\n  border-radius: 3px;\n  max-width: 100%;\n  height: auto;\n  margin-bottom: 20px;\n}\n\n.alert {\n  height: 25px;\n  width: 90px;\n  padding: 5px 0px !important;\n  text-align: center;\n  font-size: 11px;\n  font-weight: bold;\n}\n\n.card-header {\n  padding: 0.75rem 6px;\n}\n\n.card-title {\n  display: flex;\n  justify-content: space-between;\n}\n\ntable tr {\n  transition: 0.3s;\n}\n\ntable tr:hover {\n  background-color: #0000003a;\n}\n\n.banks {\n  color: #fff;\n  font-weight: bold;\n  font-size: 12px;\n}\n\n.accordion-header button {\n  width: 100%;\n  background: #000;\n  border: 0;\n  padding: 0;\n  margin: 0;\n  outline: 0;\n}\n\n.accordion-header {\n  font-size: 30px;\n  margin-bottom: 0;\n}\n\n.accordion-body {\n  margin-bottom: 15px;\n}\n\n.accordion-body .item-wrapper {\n  margin: 0;\n  padding: 0;\n}\n\n.accordion-body .item-name {\n  padding-left: 20px;\n}\n\n.m-1.alert.alert-danger,\n.m-1.alert.alert-success {\n  padding: 7px 0px;\n}\n\n.options {\n  background-color: #242424;\n  color: #fff;\n  font-size: 12px;\n}\n\n.item-wrapper {\n  border-radius: 0px;\n  margin: 0 0 2px 0;\n  padding: 5px;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  transition: 0.2s;\n  background: #212121b8;\n  border: solid 1px #363636;\n}\n.item-wrappers {\n  border-radius: 0px;\n  margin: 0 0 2px 0;\n  padding: 5px;\n\n  justify-content: space-between;\n  align-items: center;\n  transition: 0.2s;\n  background: #212121b8;\n  border: solid 1px #363636;\n}\n\n.price {\n  transition: 0.2s;\n  padding: 0 10px;\n  font-weight: bold;\n  font-size: 14px;\n  width: 100px;\n  text-align: right;\n}\n\n.table-bordered td,\n.table-bordered th {\n  color: #fff;\n}\n\n.card-title {\n  height: 60px;\n  align-items: center;\n}\n\n.dealer-title {\n  text-align: center;\n  font-size: 80px;\n  padding: 0px 100px;\n  color: #fff;\n}\n\n.card-title img.Huawei,\n.card-title img.OnePlus,\n.card-title img.Reeder,\n.card-title img.Apple {\n  height: 60px;\n}\n\n.card-title img.Omix {\n  height: 50px;\n}\n.card-title img.Xiaomi,\n.card-title img.TCL,\n.card-title img.Oppo,\n.card-title img.RealMe,\n.card-title img.Tecno {\n  height: 45px;\n}\n\n.card-title img.Poco,\n.card-title img.Vivo,\n.card-title img.Samsung {\n  height: 40px;\n}\n\n.custom-container {\n  background-color: #000;\n}\n\n.table-standart {\n  background: linear-gradient(62deg, rgb(42, 63, 181) 0%, rgb(98, 29, 52) 100%);\n  color: #fff;\n  border-radius: 20px;\n}\n\n.table-standart thead th {\n  border: 0;\n}\n\n.table-standart tr {\n  display: flex;\n  align-items: center;\n  align-items: center;\n}\n\n.table-standart td,\n.table-standart th {\n  border: 0;\n}\n\n.table-standart td strong {\n  font-size: 18px;\n}\n\n.table-standart ul {\n  text-align: left;\n}\n\n.table-standart ul li svg {\n  margin-right: 8px;\n}\n\ntable {\n  background: linear-gradient(\n    62deg,\n    rgba(42, 181, 128, 1) 0%,\n    rgba(31, 29, 98, 1) 100%\n  );\n}\n.tablecolor {\n  background: #212121b8;\n}\n\n.card {\n  background-color: transparent;\n  color: #f8f9fa;\n}\n\n.card-body ul li {\n  align-items: center;\n}\n\n.title-2 {\n  text-align: center;\n  font-weight: bold;\n  display: inline-block;\n  color: #fff;\n  transition: 0.2s;\n  cursor: default;\n}\n\n.contact-title {\n  font-size: 32px !important;\n}\n\n.alert-success {\n  color: #fff;\n  background-color: #00a473;\n  border-color: rgb(73, 219, 107);\n}\n\n.alert-danger {\n  color: #fff;\n  background-color: #a40000;\n  border-color: rgb(219, 73, 73);\n}\n\n.box1,\n.box2,\n.box3 {\n  transition: 0.3s;\n  min-height: 200px;\n}\n\n.hr-spec {\n  background-image: linear-gradient(\n    to right,\n    rgba(105, 105, 105, 0.438),\n    rgb(255 255 255 / 20%),\n    transparent\n  );\n  margin: 5px;\n  border: 0;\n  height: 1px;\n}\n\n.box3:hover,\n.box1 {\n  color: #fff;\n  background: linear-gradient(to right, #1b2f3b 50%, #000000 100%);\n  border: 5px solid transparent;\n  border-image: linear-gradient(to right, #6e0000 0%, #007da0 100%) 30 stretch;\n}\n.box2 {\n  color: #fff;\n  background: linear-gradient(to right, #332e15 50%, #000000 100%);\n  border: 5px solid transparent;\n  border-image: linear-gradient(to right, #00ffaa 0%, #2643e5 100%) 30 stretch;\n}\n\n.box2:hover,\n.box1:hover,\n.box3 {\n  color: #fff;\n  background: linear-gradient(to right, #3f1515 50%, #000000 100%);\n  border: 5px solid transparent;\n  border-image: linear-gradient(to right, #8e10f0 0%, #e52672 100%) 30 stretch;\n}\n\nhtml {\n  overflow-y: auto;\n}\n\n.header-heart {\n  animation: glowHeader 2s ease-in-out infinite alternate;\n}\n\n@keyframes glowHeader {\n  0% {\n    opacity: 0.9;\n  }\n  100% {\n    opacity: 1;\n  }\n}\n\nhr {\n  border: 1px solid transparent;\n  border-image: linear-gradient(to right, #8e10f0 0%, #e52672 100%) 30;\n}\n\n.title-wrapper {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  margin-top: 50px;\n}\n\n.border-x-side {\n  border-radius: 0 !important;\n  border-left: 1px solid #7f7f7f !important;\n  border-right: 1px solid #7f7f7f !important;\n}\n\nh1 {\n  cursor: default;\n  /* max-width: 75%; */\n  font-size: 75px;\n  text-align: center;\n  font-family: \"Montserrat\", sans-serif;\n  color: #540032;\n}\n\nh2 {\n  cursor: default;\n  font-size: 45px;\n}\n\n.contact-wrapper {\n  display: flex;\n  justify-content: end;\n}\n\n#urunler {\n  overflow: hidden;\n}\n\n.fz-17 {\n  text-align: left;\n  font-size: 17px !important;\n}\n.contact {\n  text-decoration: none;\n  color: #fff;\n  font-size: 20px;\n  text-align: right;\n  display: inline-block;\n  margin: 0;\n  cursor: pointer;\n  border-top: 0 !important;\n  border-bottom: 1px solid transparent;\n  border-image: linear-gradient(to right, #00ffaa 0%, #2643e5 100%) 30 stretch;\n\n  padding: 10px;\n  transition: 0.2s;\n}\n\n.contact-spec {\n  background-color: #e50046 !important;\n  color: #fff;\n  background: #000;\n  border-image: none !important;\n}\n\n.contact:hover {\n  border-image: linear-gradient(to right, #8e10f0 0%, #e52672 100%) 30 stretch;\n}\n\na:hover {\n  text-decoration: none;\n}\n\n@media (max-width: 1200px) {\n  h1 {\n    font-size: 70px;\n    max-width: 100%;\n    width: 100%;\n  }\n  h2 {\n    font-size: 30px;\n  }\n\n  .title {\n    max-width: 100%;\n  }\n}\n\n@media (max-width: 992px) {\n  .contact-sub-wrapper .contact-sub-title {\n    text-align: center;\n    display: block;\n    padding-bottom: 10px;\n  }\n\n  h1 {\n    font-size: 60px;\n  }\n  h2 {\n    font-size: 25px;\n  }\n}\n\n@media (max-width: 992px) {\n  .contact {\n    font-size: 14px;\n  }\n  a.dealder-area {\n    display: flex;\n    align-items: center;\n  }\n  .register-form-link {\n    font-size: 16px;\n  }\n  .dealer-title {\n    font-size: 50px;\n  }\n}\n\n@media (max-width: 768px) {\n  h1 {\n    font-size: 38px;\n  }\n  .header-heart h2 {\n    display: none !important;\n  }\n}\n\n@media (max-width: 576px) {\n  h1 {\n    font-size: 38px;\n  }\n}\n\n#iletisim ul {\n  padding: 5px;\n}\n\n#iletisim ul li {\n  cursor: pointer;\n  transition: 0.2s;\n}\n\n.contact-sub-wrapper a {\n  transition: 0.2s;\n  padding-left: 10px;\n}\n\n.contact-sub-wrapper a:hover,\n#iletisim ul li:hover {\n  color: #e50046 !important;\n}\n\n.contact-sub-wrapper svg,\n#iletisim li svg {\n  padding-right: 5px;\n}\n\n.registerBanner {\n  filter: brightness(0.7);\n}\n\n.box-info-label-area {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  height: 100%;\n  width: 100%;\n}\n\n.box-info-label li {\n  margin-top: 10px;\n  transition: 0.3s;\n  padding: 0px 0px 0px 10px;\n  cursor: default;\n}\n\n.box-info-label .li-1 {\n  width: 270px;\n  background: linear-gradient(45deg, #000000 0%, #e50046 100%) !important;\n  clip-path: polygon(90% 0%, 100% 100%, 100% 100%, 0% 100%, 0 0%, 0% 0%);\n}\n\n.box-info-label .li-2 {\n  width: 300px;\n  background: linear-gradient(45deg, #000000 0%, #860028 100%) !important;\n  clip-path: polygon(91% 0%, 100% 100%, 100% 100%, 0% 100%, 0 0%, 0% 0%);\n}\n\n.box-info-label .li-3 {\n  width: 330px;\n  background: linear-gradient(45deg, #000000 0%, #58001b 100%) !important;\n  clip-path: polygon(92% 0%, 100% 100%, 100% 100%, 0% 100%, 0 0%, 0% 0%);\n}\n\n.box-info-label .li-4 {\n  width: 360px;\n  background: linear-gradient(45deg, #000000 0%, #360010 100%) !important;\n  clip-path: polygon(92% -0%, 100% 100%, 100% 100%, 0% 100%, 0 0%, 0% 0%);\n}\n\n.box-info-label li:hover {\n  filter: grayscale(1);\n}\n\n.center-object {\n  align-items: center;\n  display: flex;\n  justify-content: center;\n}\n\n.box-info-label svg {\n  font-size: 35px;\n  color: #fff;\n  width: 40px;\n  padding-bottom: 5px;\n}\n\n.box-info-label span {\n  padding-left: 10px;\n  font-size: 52px;\n  color: #fff;\n}\n\n.dealer-button {\n  color: #fff;\n  transition: 0.2s;\n  padding: 15px;\n  border-radius: 5px;\n  display: inline-block;\n  border: solid 3px #fff;\n  cursor: pointer;\n}\n\n.dealer-text {\n  text-align: center;\n  padding: 20px 15% !important;\n}\n\n.dealer-button:hover {\n  text-shadow: 1px 1px 10px #e50046, 1px 1px 10px #e50046;\n  border: solid 3px #e50046;\n  color: #e50046;\n}\n\n.stat {\n  border-radius: 40px;\n}\n\n.parallax {\n  background-image: url(\"../images/bayi.png\");\n  min-height: 400px;\n  padding-top: 20px;\n  background-attachment: fixed;\n  background-position: center;\n  background-repeat: no-repeat;\n  background-size: cover;\n}\n\n.title {\n  background-image: url(https://cdn.pixabay.com/photo/2017/07/03/20/17/abstract-2468874_960_720.jpg);\n  background-attachment: fixed;\n  -webkit-text-fill-color: #ffffff9d;\n  -webkit-background-clip: text;\n  display: flex;\n  justify-content: center;\n  transition: 0.3s;\n}\n\n.register-form-title,\n.contact.mx-2:hover,\n.title:hover {\n  text-shadow: rgba(255, 255, 255, 0.6) 0px 0px 39px;\n}\n\n.register-container {\n  background-color: #000;\n  color: #fff;\n  padding: 20px;\n}\n\n.register-container .form-control {\n  background-color: #333;\n  color: #fff;\n  border: 1px solid #555;\n}\n\n.register-container .form-control:focus {\n  background-color: #444;\n  color: #fff;\n  border: 1px solid #777;\n}\n\n.register-container .btn-primary {\n  background-color: #007bff;\n  border: none;\n}\n\n.register-container .btn-primary:hover {\n  background-color: #0056b3;\n}\n\n.register-container .required {\n  color: red;\n}\n\n#formArea {\n  opacity: 1;\n  transition: 0.3s;\n  border: 1px solid transparent;\n  border-image: linear-gradient(to right, #ff0000 0%, #9700e5 100%) 30 stretch;\n  box-shadow: 1px 1px 10px #ff0000, 1px 1px 10px #6f00ff;\n}\n\n.h-0 {\n  height: 0;\n  opacity: 0 !important;\n}\n\n.registerForm .form-group {\n  margin-bottom: 1rem;\n}\n\n.registerForm .form-group {\n  color: #fff;\n}\n\n.registerForm label {\n  margin-left: 10px;\n}\n\n.registerForm .required {\n  color: #d80000;\n}\n\n.response {\n  width: 100%;\n  height: 35px;\n  font-size: 14px;\n}\n\n.register-form-title {\n  font-size: 70px;\n  margin: auto;\n  padding: 40px 0px;\n  background-clip: text;\n}\n\n.react-tel-input .country-list .country,\n.selected-flag,\n.registerForm .form-control {\n  background-color: #000 !important;\n  color: #fff !important;\n}\n\n.registerForm button {\n  background-color: #ba053c;\n  border: #58001b;\n}\n\n.registerForm button:active,\n.registerForm button:focus,\n.registerForm button:hover {\n  background-color: #800026 !important;\n  border: #58001b !important;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
